import script from "./wOutbound.vue?vue&type=script&setup=true&lang=ts"
export * from "./wOutbound.vue?vue&type=script&setup=true&lang=ts"

import "./wOutbound.vue?vue&type=style&index=0&id=efc8a9dc&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efc8a9dc"]])

export default __exports__